<template>
    <BModal ref="modal" :title="$t('whiteCardModal.title')" centered no-close-on-backdrop header-class="modal-title" modal-class="no-border-modal" @hidden="onHidden">
        <form ref="formRef" novalidate @submit.prevent="submit">
            <label for="white-card-number" class="form-label">{{ $t('whiteCardModal.badgeNumber') }}</label>
            <input id="white-card-number" ref="numberInput" type="text" class="form-control" v-model="number" @input="onInput"
                inputmode="numeric" :placeholder="$t('whiteCardModal.placeholder')" autocomplete="off" required />
        </form>
        <template #footer>
            <div class="d-flex justify-content-between align-items-center w-100">
                <button type="button" class="btn btn-secondary" @click="close(null)">{{ $t('common.cancel') }}</button>
                <button type="button" class="btn btn-primary ms-2" @click="submit">{{ $t('common.submit') }}</button>
            </div>
        </template>
    </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue-next';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

// Badge number added to the white list of a mechatronic reader.
// show() resolves with the number, or null when cancelled.
export default {
    name: 'WhiteCardModal',
    components: {
        BModal
    },
    setup() {
        const { t } = useI18n();
        const modal = ref(null);
        const formRef = ref(null);
        const numberInput = ref(null);
        const number = ref('');
        let resolver = null;

        const show = () => {
            number.value = '';
            modal.value.show();
            return new Promise(resolve => { resolver = resolve; });
        };

        const close = (result) => {
            const resolve = resolver;
            resolver = null;
            modal.value.hide();
            if (resolve) resolve(result);
        };

        const onHidden = () => {
            if (resolver) close(null);
        };

        const onInput = (event) => {
            event.target.setCustomValidity('');
        };

        // 1 to 17 digits as in the app, and a number JavaScript can send without rounding it
        const submit = () => {
            const value = number.value;
            const valid = value === '' || (/^\d{1,17}$/.test(value) && Number.isSafeInteger(Number(value)));
            numberInput.value.setCustomValidity(valid ? '' : t('whiteCardModal.invalid'));
            if (!formRef.value.checkValidity()) {
                formRef.value.reportValidity();
                return;
            }
            close(Number(value));
        };

        return {
            modal,
            formRef,
            numberInput,
            number,
            show,
            close,
            onHidden,
            onInput,
            submit,
        };
    }
}
</script>
